<template>
	<div>
		<div style="margin-top: 15px;">
			<div>
				<el-row :gutter="12">
					<el-col :span="4">
						<el-select v-model="type" style="width: 110px;" @change="updateTable">
							<el-option value="0" label="全部类型"></el-option>
							<el-option value="1001" label="消费"></el-option>
                            <el-option value="1002" label="充值"></el-option>
                            <el-option value="1003" label="提现"></el-option>
                            <el-option value="1004" label="分红"></el-option>
							<el-option value="1006" label="奖励"></el-option>
						</el-select>
					</el-col>
					<el-col :span="20" style="text-align:right;">
						<el-date-picker
							style="width: 235px;margin-left: 3px;"
							v-model="time"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							format="yyyy-MM-dd">
						</el-date-picker>
						<el-button type="primary" style="margin-left: 3px;" icon="el-icon-search" @click="updateTable">搜索</el-button>
					</el-col>
				</el-row>
			</div>
			<div style="margin-top: 8px;">
				<el-table ref="multipleTable"
						 :data="tableData"
						 style="width: 100%"
						 element-loading-text="数据正在加载中"
						 @selection-change="handleSelectionChange"
						 :header-cell-style="headClass"
						  :row-style="rowClass">
				    <el-table-column type="selection" width="60"></el-table-column>
				    <el-table-column prop="subject" label="账单描述" sortable width="130px"></el-table-column>
				    <el-table-column label="账单类型">
				    	<template slot-scope="scope">
				      		<div>
				      			<span v-if="scope.row.payType == 1001">消费</span>
				      			<span v-if="scope.row.payType == 1002">充值</span>
				      			<span v-if="scope.row.payType == 1006">招商奖励</span>
				      			<span v-if="scope.row.payType == 1004">分红</span>
                                <span v-if="scope.row.payType == 1007">让利</span>
				      		</div>
				      	</template>
				    </el-table-column>
          <el-table-column prop="belongNickname" label="账单归属方"></el-table-column>
<!--				    <el-table-column label="操作人类型">-->
<!--				    	<template slot-scope="scope">-->
<!--				      		<div>-->
<!--				      			<span v-if="scope.row.roleType == 1">客户</span>-->
<!--				      			<span v-if="scope.row.roleType == 2">二级代理商</span>-->
<!--				      			<span v-if="scope.row.roleType == 3">一级代理商</span>-->
<!--				      			<span v-if="scope.row.roleType == 4">品牌商</span>-->
<!--                                <span v-if="scope.row.roleType == 8">三级代理商</span>-->
<!--                                <span v-if="scope.row.roleType == 9">运营商</span>-->
<!--                                <span v-if="scope.row.roleType == 10">推广人员</span>-->
<!--				      		</div>-->
<!--				      	</template>-->
<!--				    </el-table-column>-->
				    <el-table-column prop="nickName" label="操作人"></el-table-column>
				    <el-table-column label="金额">
                        <template slot-scope="scope">
				      		<div>
                                <span>{{moneyFormat(scope.row.amount)}}</span>
				      		</div>
				      	</template>
                    </el-table-column>
				    <el-table-column prop="paytime" label="完成时间" :formatter="dateFormat"></el-table-column>
				    <el-table-column prop="payId" label="支付交易号"></el-table-column>
				    <el-table-column label="操作">
				      	<template slot-scope="scope">
				      		<button @click="getMessage(scope.row)">查看</button>
				      	</template>
				    </el-table-column>
				</el-table>
				<el-pagination background
				    	style="text-align:right;margin-top: 15px;margin-bottom: 65px;"
				        @size-change="handleSizeChange"
				        @current-change="handleCurrentChange"
				        :current-page="currentPage"
				        :page-sizes="[10, 50, 100, 200]"
				        :page-size="pageSize"
				        layout="total, sizes, prev, pager, next, jumper"
				        :total="total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'billCenter',
  components: {
  },
  data() {
    return {
    	total: 0,
      	currentPage: 1,
　　  	pageSize: 10,
		multipleSelection: [],
		tableData:[],
		type:"0",
		time:[]
    }
  },
  watch: {
  },
  mounted() {
  	this.updateTable();
  },
  beforeDestroy() {
  },
  methods: {
  	handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  	handleSizeChange(val) {
      this.pageSize = val;
      this.updateTable();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.updateTable();
    },
    headClass({ row, rowIndex}) {
    	if(rowIndex == 0){
    		return ''
    	}
	    return ''
	},
    rowClass({ row, rowIndex}) {
	    if(rowIndex%2 == 0){
	    	return 'background:#F1F2F7;'
	    }else{
	    	return 'background:white;'
	    }
	    return ''
	},
	updateTable(){
		var thiz = this;
    	var param = {
  				pageId:this.currentPage,
  				size:this.pageSize,
  				type:this.type
  			}
  		if(this.time != null && this.time.length > 0){
	  		param.startDate = this.getStandardDate(this.time[0]);
	  		param.endDate = this.getStandardDate(this.time[1]);
	  	}
  		const loading = this.$loading({
          lock: true,
          text: '获取表格数据中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 3000);
    	axios.get(this.$store.getters.getApiValue+'/income/listBillings.do',{
  			params:param
  		}).then(function (response) {
  			loading.close();
		    var data = response.data;
		    if(data.status == "200"){
		    	thiz.total = data.totalCount;
		    	thiz.tableData = data.data;
		    }else{
		    	thiz.$message.error("查询异常");
		    }
		  }).catch(function (error) {
		  	loading.close();
		    console.log(error);
		    thiz.$message.error("系统异常，请与管理员联系!");
		  });
    },
    getStandardDate(val){
    	var year = val.getFullYear();
        var month = val.getMonth() + 1;
        var day = val.getDate();
        month = month < 10 ? "0"+month : month;
        day = day < 10 ? "0"+day : day;
        return year+"-"+month+"-"+day;
   	},
	dateFormat(row,column){
		var str = row[column.property];
		if(str == null || str == ""){
			return "";
		}else{
			return this.getFullStandardDate(str);
		}
	},
    getMessage(row){
    	alert(row.subject);
    },
    getFullStandardDate(str){
    	var val = new Date(str)
    	var year = val.getFullYear();
        var month = val.getMonth() + 1;
        var day = val.getDate();
        var hour = val.getHours();
        var minute = val.getMinutes();
        var second = val.getSeconds();
        month = month < 10 ? "0"+month : month;
        day = day < 10 ? "0"+day : day;
        hour = hour < 10 ? "0"+hour : hour;
        minute = minute < 10 ? "0"+minute : minute;
        second = second < 10 ? "0"+second : second;
        return year+"-"+month+"-"+day+" "+hour+":"+minute+":"+second;
    },
        moneyFormat(val){
        // val = val.toString().replace(/[^\d.]/g,""); //清除"数字"和"."以外的字符
        let val1 = parseFloat(val).toFixed(2);  //保留两位小数
        let val2 = val1.toString();
        let arr = val2.split('.');
        let arr1 = arr[0].split('');
        let str3 = "";
        let arr2 = [];
        for(let i=arr1.length-1,j=0;i>=0;i--,j++) {
          str3 = '' + arr1[i] + str3;
          if(j%3==2) {
            arr2.unshift(str3)
            str3 = "";
          }else if(i==0) {
            arr2.unshift(str3)
          }
        }
        let str4 = arr2.join(',');
        let str5 = str4 + '.' + arr[1];
        return str5;
    }
  }
}
</script>

<style>
	.el-table{
	  	font-size: 12px;
	  	border-bottom: 1px solid #dcd8d8;
	  	color: black;
	}
	.el-table tr th{
	    border-top: 0px;
	  	border-left: 0px;
	  	border-right: 0px;
	}
	.el-table tr td{
	  	border-bottom: 1px solid #dcd8d8;
 	}
</style>
